export const NOOP = () => {
  // do nothing
};
